var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Clients"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"title-box"},[_vm._v(_vm._s(_vm.$t("clientes.titulo")))]),_vm._v(" "),_c('article',[_c('ul',_vm._l((_vm.clients),function(client){return _c('li',[_c('a',{attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"responsiva",attrs:{"src":client.image,"alt":client.name}})])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c86e8f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Clients.vue
// module id = 87
// module chunks = 0